






























import { getFormattedAddressData } from '@checkout/helpers';
import { useUserStore } from '@checkout/stores';
import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent, useContext } from '@nuxtjs/composition-api';
import VaimoButton from 'atoms/VaimoButton.vue';
import { storeToRefs } from 'pinia';

import type { Address } from '~/models';
import { AddressTypeEnum } from '~/models';

export default defineComponent({
  name: 'AddressOption',
  components: {
    VaimoButton
  },
  props: {
    data: {
      type: Object as PropType<Address>,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit', 'select'],
  setup(props, { emit }) {
    const userStore = useUserStore();
    const { isGuestUser } = storeToRefs(userStore);
    const { i18n } = useContext();

    const handleClick = () => {
      emit('select');
    };

    const editAddress = () => {
      emit('edit');
    };

    const formattedAddressLines = computed(() => {
      return getFormattedAddressData(props.data, { isAddressOptionView: true });
    });

    const isDefaultAddress = computed(() => {
      return (
        props.data.default_shipping ||
        props.data.default_billing ||
        isGuestUser.value
      );
    });

    const defaultAddressLabel = computed(() => {
      if (isGuestUser.value) {
        return props.data.address_book_type === AddressTypeEnum.SHIPPING
          ? i18n.t('checkout.shipping.default_address.guest_shipping')
          : i18n.t('checkout.shipping.default_address.guest_billing');
      }
      if (props.data.default_shipping) {
        return i18n.t('checkout.shipping.default_address.shipping');
      } else if (props.data.default_billing) {
        return i18n.t('checkout.shipping.default_address.billing');
      }
    });

    return {
      handleClick,
      editAddress,
      formattedAddressLines,
      isDefaultAddress,
      defaultAddressLabel
    };
  }
});
